/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import {PropTypes} from 'preact-compat';
import styles from '../../../css/stats.css';

const StatItem = ({label, rate, direction}) => (
  <h4 className={styles.item}>
    <span className={styles.label}>{label} {direction}</span>
    <div className={styles.numberContainer}>
      <div className={styles.number}>
        {convertBitRate(rate)}
      </div>
      <div className={styles.unitOfMeasure}>kbps</div>
    </div>
  </h4>
);

StatItem.propTypes = {
  label: PropTypes.string.isRequired,
  rate: PropTypes.number.isRequired,
  direction: PropTypes.string.isRequired
};

const StatsView = ({audioStat, videoStat, isUpload}) => {
  const direction = isUpload ? '↑' : '↓';
  const getRate = (stat) => isUpload ? stat.uploadRate : stat.downloadRate;

  return (
    <div className={styles.container}>
      {videoStat && (
        <StatItem
          label="Video"
          rate={getRate(videoStat)}
          direction={direction}
        />
      )}
      {audioStat && (
        <StatItem
          label="Audio"
          rate={getRate(audioStat)}
          direction={direction}
        />
      )}
    </div>
  );
};

StatsView.propTypes = {
  audioStat: PropTypes.shape({
    uploadRate: PropTypes.number,
    downloadRate: PropTypes.number
  }),
  videoStat: PropTypes.shape({
    uploadRate: PropTypes.number,
    downloadRate: PropTypes.number
  }),
  isUpload: PropTypes.bool
};

StatsView.defaultProps = {
  audioStat: null,
  videoStat: null,
  isUpload: false
};

function convertBitRate(bitRateInKilobitsPerSecond = 0, precision = 2) {
  return bitRateInKilobitsPerSecond.toFixed(precision);
}

export default StatsView;